/* siteSyncing.js */

"use strict";
/* global Slick */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const {
    Control: {
        Action: {Button},
    },
} = uiCore;
const formatters = require("../../cellFormaters");
// const checkBoxEditor = require("../../cellEditors/CheckBoxEditor");
// const FieldEditor = require("../../cellEditors/FieldEditor");
const SelectBoxEditor = require("../../cellEditors/SelectBoxEditor");
const GluSitePropEditor = require("../../cellEditors/GluSitePropEditor");

/**
 * Any functions named with XdToGlu belong to the second grid which is XDome To Gluware.
 * Without it is for the Gluware to XDome grid
 */
class SiteSyncing {
    /**
     * Constructor
     * @param {*} model
     */
    constructor(model) {
        this._model = model;
        this._bindEventHandlers();

        this._tableOptions = this._initializeTableOptions();
        this._createEmptyBanners();

        // this._siteAndCiSyncingContainer = this._createSectionContainer(
        //     "xd-site-and-ci-syncing-container",
        //     "From Gluware to xDome"
        // );
        this._siteAndCiSyncingContainerXdToGlu = this._createSectionContainer(
            "site-and-ci-syncing-n-t-g-container",
            "From Claroty xDome to Gluware"
        );

        // const slickTableSnCSContainerMain = document.createElement("slick-table-cmdb-container");
        const slickTableSnCSContainerMainXdToGlu = document.createElement(
            "slick-table-n-t-g-cmdb-container"
        );

        this._addNewRowSnCSButton = new Button({
            label: "Add Rule +",
            active: true,
        });

        this._addNewRowSnCSButton_XdToGlu = new Button({
            label: "Add Rule +",
            active: true,
        });

        // this._slickTableSnCSContainer = document.createElement("slick-table-cmdb");
        this._slickTableSnCSContainer_XdToGlu = document.createElement("slick-table-cmdb");

        // slickTableSnCSContainerMain.appendChild(this._slickTableSnCSContainer);
        slickTableSnCSContainerMainXdToGlu.appendChild(this._slickTableSnCSContainer_XdToGlu);

        const addRowButtonSnCSContainer = document.createElement("div");
        addRowButtonSnCSContainer.classList.add("add-new-rule-container");

        const addRowButtonSnCSContainer_XdToGlu = document.createElement("div");
        addRowButtonSnCSContainer_XdToGlu.classList.add("add-new-rule-container");

        // slickTableSnCSContainerMain.appendChild(this._noMappingSyncing);
        // slickTableSnCSContainerMain.appendChild(this._noVendorMapSyncing);
        // slickTableSnCSContainerMain.appendChild(this._noDataSyncing);

        slickTableSnCSContainerMainXdToGlu.appendChild(this._noMappingSyncing_XdToGlu);
        slickTableSnCSContainerMainXdToGlu.appendChild(this._noVendorMapSyncing_XdToGlu);
        // slickTableSnCSContainerMainXdToGlu.appendChild(this._noDataSyncing_XdToGlu);

        addRowButtonSnCSContainer.appendChild(this._addNewRowSnCSButton._renderer._rootElem);
        addRowButtonSnCSContainer_XdToGlu.appendChild(
            this._addNewRowSnCSButton_XdToGlu._renderer._rootElem
        );

        // slickTableSnCSContainerMain.appendChild(addRowButtonSnCSContainer);
        slickTableSnCSContainerMainXdToGlu.appendChild(addRowButtonSnCSContainer_XdToGlu);

        // this._slickSnCSTable = undefined;
        this._slickSnCSTable_XdToGlu = undefined;

        // this._columnsSnCS = [
        //     {
        //         id: "gwAttr",
        //         width: 350,
        //         name: "Gluware Property",
        //         field: "gwAttr",
        //         resizable: true,
        //         toolTip: "Gluware Property",
        //         formatter: formatters.gwSiteAttributeFormatter,
        //         editor: GluSitePropEditor,
        //     },
        //     {
        //         id: "cmdbAttr",
        //         width: 350,
        //         name: "XDome Property",
        //         field: "cmdbAttr",
        //         resizable: true,
        //         toolTip: "XDome Property",
        //         formatter: formatters.ciXDomeAttributeFormatter,
        //         editor: SelectBoxEditor,
        //     },
        //     {
        //         id: "deleteRow",
        //         width: 90,
        //         name: "Action",
        //         field: "deleteRow",
        //         selectable: false,
        //         resizable: false,
        //         cssClass: "cell-delete dnd centered",
        //         formatter: formatters.deleteButtonFormatter,
        //         headerCssClass: "centered",
        //     },
        // ];

        this._columnsSnCS_XdToGlu = [
            {
                id: "cmdbAttr",
                width: 350,
                name: "Claroty xDome Property",
                field: "cmdbAttr",
                resizable: true,
                toolTip: "Claroty xDome Property",
                formatter: formatters.ciXDomeAttributeFormatter,
                editor: SelectBoxEditor,
            },
            {
                id: "gwAttr",
                width: 350,
                name: "Gluware Property",
                field: "gwAttr",
                resizable: true,
                toolTip: "Gluware Property",
                formatter: formatters.gwSiteAttributeFormatter,
                editor: GluSitePropEditor,
            },
            {
                id: "deleteRow",
                width: 90,
                name: "Action",
                field: "deleteRow",
                selectable: false,
                resizable: false,
                cssClass: "cell-delete dnd centered",
                formatter: formatters.deleteButtonFormatter,
                headerCssClass: "centered",
            },
        ];

        // this._siteAndCiSyncingContainer.appendChild(slickTableSnCSContainerMain);
        this._siteAndCiSyncingContainerXdToGlu.appendChild(slickTableSnCSContainerMainXdToGlu);

        this._registerEventListeners();
    }

    // INITIALIZATION HELPERS - START

    _bindEventHandlers() {
        // this._onSnCSRowCountChange = this._onSnCSRowCountChange.bind(this);
        // this._onSnCSCellChangeAction = this._onSnCSCellChangeAction.bind(this);
        // this._onSnCSRowsChanged = this._onSnCSRowsChanged.bind(this);

        this._onSnCSRowCountChange_XdToGlu = this._onSnCSRowCountChange_XdToGlu.bind(this);
        this._onSnCSCellChangeAction_XdToGlu = this._onSnCSCellChangeAction_XdToGlu.bind(this);
        this._onSnCSRowsChanged_XdToGlu = this._onSnCSRowsChanged_XdToGlu.bind(this);

        this._documentClickHandler = this._documentClickHandler.bind(this);
    }

    _initializeTableOptions() {
        return {
            editable: true,
            enableCellNavigation: true,
            enableAsyncPostRender: true,
            forceFitColumns: true,
            autoHeight: false,
            autoEdit: true,
            resizable: false,
            rowHeight: 40,
        };
    }

    _createEmptyBanners() {
        this._noDataSyncing = this._createEmptyBanner(
            "Unable to connect to Claroty xDome. Please verify configured connection details.",
            "no-cmdb-connection"
        );
        this._noVendorMapSyncing = this._createEmptyBanner(
            "No Vendor OS Map available for the Organization.",
            "no-vendor-map"
        );
        this._noMappingSyncing = this._createEmptyBanner(
            "No Syncing Rules Specified.",
            "no-mapping"
        );

        this._noDataSyncing_XdToGlu = this._createEmptyBanner(
            "Unable to connect to Claroty xDome. Please verify configured connection details.",
            "no-cmdb-connection"
        );
        this._noVendorMapSyncing_XdToGlu = this._createEmptyBanner(
            "No Vendor OS Map available for the Organization.",
            "no-vendor-map"
        );
        this._noMappingSyncing_XdToGlu = this._createEmptyBanner(
            "No Syncing Rules Specified.",
            "no-mapping"
        );
    }

    _createSectionContainer(className, titleText) {
        const container = document.createElement("div");
        container.classList.add(className);

        const sectionTitle = document.createElement("div");
        sectionTitle.classList.add("section-title");
        sectionTitle.innerText = titleText;

        container.appendChild(sectionTitle);
        return container;
    }

    // INITIALIZATION HELPERS - END

    // EVENT REGISTRATIONS - START
    _registerEventListeners() {
        this._addNewRowSnCSButton.on(
            "UserClick",
            (this._addS2CSyncingClick = this._addS2CSyncingClick.bind(this))
        );
        this._addNewRowSnCSButton_XdToGlu.on(
            "UserClick",
            (this.addNewS2CSyncingRule_XdToGlu = this.addNewS2CSyncingRule_XdToGlu.bind(this))
        );
        this._model.on(
            "RefreshSiteAndCiSyncingGrid",
            (this.resetSnCSSlickTable = this.resetSnCSSlickTable.bind(this, "gw_to_xd"))
        );
        this._model.on(
            "RefreshSiteAndCiSyncingXDomeToGluGrid",
            (this.resetSnCSXdToGluSlickTable = this.resetSnCSXdToGluSlickTable.bind(
                this,
                "xd_to_gw"
            ))
        );
        this._model.on(
            "ErrorInSiteSyncing",
            (this._errorInSyncing = this._errorInSyncing.bind(this))
        );
        this._model.on(
            "ErrorInSiteSyncingXdToGlu",
            (this._errorInSyncing_XdToGlu = this._errorInSyncing_XdToGlu.bind(this))
        );
    }

    _unregisterEventListeners() {
        this._addNewRowSnCSButton.removeListener("UserClick", this._addS2CSyncingClick);
        this._addNewRowSnCSButton_XdToGlu.removeListener(
            "UserClick",
            this.addNewS2CSyncingRule_XdToGlu
        );
        this._model.removeListener("RefreshDeviceAndCiSyncingGrid", this.resetSnCSSlickTable);
        this._model.removeListener(
            "RefreshSiteAndCiSyncingXdToGluGrid",
            this.resetSnCSXdToGluSlickTable
        );
        this._model.removeListener("ErrorInSyncingXdToGlu", this._errorInSyncing_XdToGlu);
        this._model.removeListener("ErrorInSyncing", this._errorInSyncing);

        this._unregisterDocumentListener();
    }

    _registerDocumentListener() {
        document.addEventListener("click", this._documentClickHandler);
    }

    _unregisterDocumentListener() {
        document.removeEventListener("click", this._documentClickHandler);
    }

    // EVENT REGISTRATIONS - END

    // SLICK EVENT REGISTRATIONS - START

    _registerDnCSSlickTableListeners(type) {
        const typeAppend = type === "gw_to_xd" ? "" : "_XdToGlu";
        if (this["_slickSnCSTable" + typeAppend]) {
            this["_slickSnCSTable" + typeAppend].onCellChange.subscribe(
                this["_onSnCSCellChangeAction" + typeAppend]
            );
            this["_slickSnCSDataVIew" + typeAppend].onRowCountChanged.subscribe(
                this["_onSnCSRowCountChange" + typeAppend]
            );
            this["_slickSnCSDataVIew" + typeAppend].onRowsChanged.subscribe(
                this["_onSnCSRowsChanged" + typeAppend]
            );
        }
    }

    // SLICK EVENT REGISTRATIONS - END

    // EVENTS - START

    _addS2CSyncingClick() {
        this._model.addNewS2CSyncingRule();
    }
    addNewS2CSyncingRule_XdToGlu() {
        this._model.addNewS2CSyncingRule_XdToGlu();
    }

    _errorInSyncing(ids = []) {
        ids.forEach((id) => {
            const rowIndex = this._slickSnCSTable.getData().getIdxById(id);
            const currentRow = this._slickSnCSTable.getCanvasNode().children[rowIndex];
            currentRow.classList.add("error-row");
        });
    }
    _errorInSyncing_XdToGlu(ids = []) {
        ids.forEach((id) => {
            const rowIndex = this._slickSnCSTable_XdToGlu.getData().getIdxById(id);
            const currentRow = this._slickSnCSTable_XdToGlu.getCanvasNode().children[rowIndex];
            currentRow.classList.add("error-row");
        });
    }

    _documentClickHandler(evt) {
        this._saveAndCloseEditCellAction(evt);
    }

    // EVENTS - END

    // RENDER METHODS - START

    _getSiteCISyncingContent() {
        const _tabMainContent = document.createElement("div");
        _tabMainContent.classList.add("content-main", "xd-site-to-ci-syncing");

        // _tabMainContent.appendChild(this._siteAndCiSyncingContainer);
        _tabMainContent.appendChild(this._siteAndCiSyncingContainerXdToGlu);

        _tabMainContent.appendChild(this._noDataSyncing);

        this._tabContent = _tabMainContent;
        return this._tabContent;
    }

    _createEmptyBanner(msg, className) {
        const msgContainer = document.createElement("div");
        msgContainer.classList.add(className);
        const innerSpan = document.createElement("span");
        innerSpan.innerText = msg;

        msgContainer.appendChild(innerSpan);

        return msgContainer;
    }

    _createNoDataPlaceholder() {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        noDataPlaceholder.innerText = "No Sync Rules Available";
        return noDataPlaceholder;
    }

    /**
     * Shows banner if no mappings
     */
    _entityContainsMapping(type) {
        const typeAppend = type === "gw_to_xd" ? "" : "_XdToGlu";
        const dataForSyncMapping = this._model._xdDataSyncConfigEntity.getDataSyncMappings() || {},
            deviceValueMaps = _.get(dataForSyncMapping, "valueMapping.site", []);
        if (_.isEmpty(deviceValueMaps)) {
            this["_noMappingSyncing" + typeAppend].classList.add("show");
        } else {
            this["_noMappingSyncing" + typeAppend].classList.remove("show");
        }
    }

    /**
     * Shows empty banner if no data to show
     * @param {*} state
     * @param {*} container
     */
    _toggleNoDataPlaceholder(state, container, type) {
        const typeAppend = type === "gw_to_xd" ? "" : "_XdToGlu";
        container.classList.toggle("empty", state);
        if (!state) {
            this["_noMappingSyncing" + typeAppend].classList.remove("show");
        }
    }

    _renderSnCSSlickGrid(data, type) {
        const typeAppend = type === "gw_to_xd" ? "" : "_XdToGlu";

        if (!this["_slickSnCSTable" + typeAppend]) {
            this["_slickTableSnCSContainer" + typeAppend].classList.add("slick-table-height-hack");
            this["_slickSnCSDataVIew" + typeAppend] = new Slick.Data.DataView();
            this["_slickSnCSDataVIew" + typeAppend].setItems(data || []);
            this["_slickSnCSTable" + typeAppend] = new Slick.Grid(
                this["_slickTableSnCSContainer" + typeAppend],
                this["_slickSnCSDataVIew" + typeAppend],
                this["_columnsSnCS" + typeAppend],
                this["_tableOptions"]
            );
            setTimeout(() => {
                this["_slickTableSnCSContainer" + typeAppend].classList.remove(
                    "slick-table-height-hack"
                );
            }, 0);

            this._registerDnCSSlickTableListeners(type);

            this["_slickTableSnCSContainer" + typeAppend].appendChild(
                this._createNoDataPlaceholder()
            );
        }
    }

    // RENDER METHODS - END

    // SLICK DELETE ACTION - START
    _deleteSnCSItem(id, type, propName) {
        const deleteConfirmation = () => {
            const deleteMessage = `Are you sure you want to delete '${propName}' from the sync process?`;

            return this._model._uiUtils.showDeleteConfirmDialog({
                message: deleteMessage,
                confirmButtonName: "Confirm",
                cancelButtonName: "Cancel",
            });
        };

        return deleteConfirmation()
            .then(() => {
                this._model.deleteSiteInstanceSyncingCriteria(id, type);
                if (type === "GW_TO_XD") {
                    this._slickSnCSDataVIew.deleteItem(id);
                    this._slickSnCSTable.invalidate();
                } else {
                    this._slickSnCSDataVIew_XdToGlu.deleteItem(id);
                    this._slickSnCSTable_XdToGlu.invalidate();
                }

                this._model.setDataSyncMappings();
                this._model.emit("validateCMDBSyncIntegrations");
            })
            .catch((error) => error && this._showError(error));
    }

    // SLICK DELETE ACTION - END

    // HELPER METHODS - START

    resetSnCSSlickTable(type) {
        const typeAppend = type === "gw_to_xd" ? "" : "_XdToGlu";
        if (this["_slickSnCSTable" + typeAppend]) {
            if (!_.isUndefined(this._model["_dataForSlickTableSiteSyncing" + typeAppend])) {
                this["_slickSnCSDataVIew" + typeAppend].setItems(
                    this._model["_dataForSlickTableSiteSyncing" + typeAppend]
                );
                // this._sortTable();

                this["_slickSnCSTable" + typeAppend].invalidate();

                this["_slickSnCSTable" + typeAppend].render();

                this["_slickSnCSTable" + typeAppend].resizeCanvas();

                this._model.emit("validateCMDBSyncIntegrations");

                this._errorInSyncing(this._model["errSyncingIds" + typeAppend]);
                this._toggleNoDataPlaceholder(
                    !this._model["_dataForSlickTableSiteSyncing" + typeAppend].length,
                    this["_slickTableSnCSContainer" + typeAppend],
                    type
                );
            }
        } else {
            this._renderSnCSSlickGrid(
                this._model["_dataForSlickTableSiteSyncing" + typeAppend],
                type
            );
        }
    }

    resetSnCSXdToGluSlickTable(type) {
        const typeAppend = "_XdToGlu";
        if (this["_slickSnCSTable" + typeAppend]) {
            if (!_.isUndefined(this._model["_dataForSlickTableSiteSyncing" + typeAppend])) {
                this["_slickSnCSDataVIew" + typeAppend].setItems(
                    this._model["_dataForSlickTableSiteSyncing" + typeAppend]
                );
                // this._sortTable();
                // slick-table-height-hack class with a large height is added before render
                // to provide slick grid with fixed large height ad then removed after render
                // to fix the issue mentioned in JIRA PE-12890
                this["_slickTableSnCSContainer" + typeAppend].classList.add(
                    "slick-table-height-hack"
                );

                this["_slickSnCSTable" + typeAppend].invalidate();

                this["_slickSnCSTable" + typeAppend].render();

                this["_slickSnCSTable" + typeAppend].resizeCanvas();
                setTimeout(() => {
                    this["_slickTableSnCSContainer" + typeAppend].classList.remove(
                        "slick-table-height-hack"
                    );
                }, 0);

                this._model.emit("validateCMDBSyncIntegrations");

                this._errorInSyncing(this._model["errSyncingIds" + typeAppend]);
                this._toggleNoDataPlaceholder(
                    !this._model["_dataForSlickTableSiteSyncing" + typeAppend].length,
                    this["_slickTableSnCSContainer" + typeAppend],
                    type
                );
            }
        } else {
            this._renderSnCSSlickGrid(
                this._model["_dataForSlickTableSiteSyncing" + typeAppend],
                "xd_to_gw"
            );
        }
    }

    async _resetSnCSData() {
        await this._model._generateSlickDataForInstanceSyncing();
    }

    _connectionFailed() {
        this._noDataSyncing.classList.add("show");
        this._tabContent.classList.add("no-connection");
    }

    _connectionPassed() {
        this._noDataSyncing.classList.remove("show");
        this._tabContent.classList.remove("no-connection");
    }

    /**
     * Sets the valuedata in the entity and triggers a validation to enable/disable the save/cancel buttons
     */
    _setSnCSInEntityAndEnableDisableActions() {
        this._model.setDataSyncMappings();
        this._model.emit("validateCMDBSyncIntegrations");
    }

    /**
     * This method is first called when the Device Syncing Tab is clicked.
     * From here, the rest of the flow continues
     */
    _tabClick() {
        this._registerDocumentListener();

        // this._renderSnCSSlickGrid(undefined, "gw_to_xd");
        this._renderSnCSSlickGrid(undefined, "xd_to_gw");
        setTimeout(() => {
            this._slickSnCSTable_XdToGlu.resizeCanvas();
        }, 0);

        // this._slickSnCSTable.resizeCanvas();
    }

    _saveAndCloseEditCellAction(e) {
        //do nothing if no active editors
        const slickTables = [/*this._slickSnCSTable, */ this._slickSnCSTable_XdToGlu];
        const tablesWithActiveEditors = slickTables.filter((table) =>
            table.getEditorLock().isActive()
        );
        if (tablesWithActiveEditors.length === 0) {
            return false;
        }
        tablesWithActiveEditors.forEach((table) => {
            //get event bubbling path
            const path = e.path || e.composedPath();
            //check if click was outside of current editing cell
            let outsideClick = true;
            _.each(path, (element) => {
                const elHasClass = (className) =>
                    element.classList && element.classList.contains(className);
                if (elHasClass("slick-cell")) {
                    const cellHasActiveEditor = elHasClass("active") && elHasClass("editable");
                    outsideClick = !cellHasActiveEditor;
                    return false;
                }
                if (element.tagName === "SLICK-TABLE-CMDB") {
                    return false;
                }
            });
            if (outsideClick) {
                table.getEditorLock().commitCurrentEdit();
            }
        });
    }

    // HELPER METHODS - END

    /* SLICK EVENTS : START */

    // _onSnCSRowCountChange(event, {/*previous,*/ current}) {
    //     this._slickSnCSDataVIew.refresh();
    //     this._toggleNoDataPlaceholder(!current, this._slickTableSnCSContainer, "gw_to_xd"); // Create new no data holder
    // }
    // _onSnCSRowsChanged() {
    //     this._model.emit("validateCMDBSyncIntegrations");
    // }
    // _onSnCSCellChangeAction() {
    //     const slickRows = this._slickSnCSTable.getCanvasNode().children;
    //     for (let currentRow of slickRows) {
    //         currentRow.classList.remove("error-row");
    //     }

    //     this._setSnCSInEntityAndEnableDisableActions();
    // }

    _onSnCSRowCountChange_XdToGlu(event, {/*previous,*/ current}) {
        this._slickSnCSDataVIew_XdToGlu.refresh();
        this._toggleNoDataPlaceholder(!current, this._slickTableSnCSContainer_XdToGlu, "xd_to_gw"); // Create new no data holder
    }
    _onSnCSRowsChanged_XdToGlu() {
        this._model.emit("validateCMDBSyncIntegrations");
    }
    _onSnCSCellChangeAction_XdToGlu() {
        const slickRows = this._slickSnCSTable_XdToGlu.getCanvasNode().children;
        for (let currentRow of slickRows) {
            currentRow.classList.remove("error-row");
        }

        this._setSnCSInEntityAndEnableDisableActions();
    }

    /* SLICK EVENTS : END */
}

module.exports = SiteSyncing;
